import { render, staticRenderFns } from "./ExpressManageButton.vue?vue&type=template&id=685b4c6a&scoped=true"
import script from "./ExpressManageButton.vue?vue&type=script&lang=js"
export * from "./ExpressManageButton.vue?vue&type=script&lang=js"
import style0 from "./ExpressManageButton.vue?vue&type=style&index=0&id=685b4c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b4c6a",
  null
  
)

export default component.exports